/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Login_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_microsoft = /** @type {((inputs?: Login_MicrosoftInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_MicrosoftInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verder met Microsoft")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec Microsoft")
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});